"use client";

import { Route } from "@faire/web-api/Route";
import { props as merchandisedCollectionRouteProps } from "@faire/web-api/routes/merchandised-collection/mcVanityUrl";
import React from "react";

import { MerchandisedCollection } from "@faire/retailer/features/MerchandisedCollection/MerchandisedCollection";

export const RenderMerchandiseCollection = () => {
  return (
    <Route
      {...merchandisedCollectionRouteProps}
      component={MerchandisedCollection}
    />
  );
};
